import React, { useState, useEffect } from "react";
import "./EditNewsPopup.css";

function EditNewsPopup({ isOpen, onClose, news, onSubmit }) {
  const [formData, setFormData] = useState({
    title: "",
    content: "",
    images: [],
    remove_images: [],
  });

  const [existingImages, setExistingImages] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (news) {
      setFormData({
        title: news.title || "",
        content: news.content || "",
        images: [],
        remove_images: [],
      });
      // Теперь image_urls уже является массивом, не нужно делать split
      setExistingImages(news.image_urls || []);
    }
  }, [news]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleImageChange = (e) => {
    const files = Array.from(e.target.files);
    setFormData((prev) => ({
      ...prev,
      images: files,
    }));
  };

  const handleRemoveImage = (imageUrl) => {
    setExistingImages((prev) => prev.filter((url) => url !== imageUrl));
    setFormData((prev) => ({
      ...prev,
      remove_images: [...prev.remove_images, imageUrl],
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    try {
      // Создаем FormData для отправки multipart/form-data
      const formDataToSend = new FormData();
      formDataToSend.append("title", formData.title);
      formDataToSend.append("content", formData.content);

      // Добавляем все новые изображения
      formData.images.forEach((image) => {
        formDataToSend.append("images", image);
      });

      // Добавляем массив удаляемых изображений
      formData.remove_images.forEach((imageUrl) => {
        formDataToSend.append("remove_images", imageUrl);
      });

      await onSubmit(formDataToSend);
      onClose();
    } catch (error) {
      console.error("Ошибка при обновлении новости:", error);
    } finally {
      setIsLoading(false);
    }
  };

  if (!isOpen || !news) return null;

  return (
    <div className="popup-overlay" onClick={onClose}>
      <div className="edit-news-popup" onClick={(e) => e.stopPropagation()}>
        {isLoading && (
          <div className="edit-news-popup__loader">
            <div className="loader"></div>
          </div>
        )}
        <h3 className="edit-news-popup__title">Редактирование новости</h3>
        <form onSubmit={handleSubmit} className="edit-news-popup__form">
          <div className="edit-news-popup__field">
            <label>Заголовок</label>
            <input
              type="text"
              name="title"
              value={formData.title}
              onChange={handleInputChange}
              required
              minLength={1}
              maxLength={100}
            />
          </div>

          <div className="edit-news-popup__field">
            <label>Текст новости</label>
            <textarea
              name="content"
              value={formData.content}
              onChange={handleInputChange}
              required
              minLength={1}
              maxLength={5000}
            />
          </div>

          <div className="edit-news-popup__field">
            <label>Текущие изображения</label>
            <div className="edit-news-popup__images-grid">
              {existingImages.map(
                (imageUrl, index) =>
                  !formData.remove_images.includes(imageUrl) && (
                    <div
                      key={index}
                      className="edit-news-popup__image-container"
                    >
                      <img
                        src={imageUrl} // Используем URL напрямую
                        alt={`Изображение ${index + 1}`}
                        className="edit-news-popup__image"
                      />
                      <button
                        type="button"
                        onClick={() => handleRemoveImage(imageUrl)}
                        className="edit-news-popup__remove-image"
                      >
                        ×
                      </button>
                    </div>
                  )
              )}
            </div>
          </div>

          <div className="edit-news-popup__field">
            <label>Добавить новые изображения</label>
            <input
              type="file"
              multiple
              accept=".jpg,.jpeg,.png"
              onChange={handleImageChange}
            />
            <small className="edit-news-popup__hint">
              Поддерживаемые форматы: JPG, JPEG, PNG
            </small>
          </div>

          <div className="edit-news-popup__buttons">
            <button
              type="submit"
              className="edit-news-popup__submit"
              disabled={isLoading}
            >
              {isLoading ? "Сохранение..." : "Сохранить"}
            </button>
            <button
              type="button"
              onClick={onClose}
              className="edit-news-popup__cancel"
              disabled={isLoading}
            >
              Отмена
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default EditNewsPopup;
